import { render, staticRenderFns } from "./CatalogPolicyIndex.vue?vue&type=template&id=6b177e84&scoped=true"
import script from "./CatalogPolicyIndex.vue?vue&type=script&lang=js"
export * from "./CatalogPolicyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b177e84",
  null
  
)

export default component.exports